// PRD §5.4 — events visible on the public QR page.
//
// The QR page is consumed by anonymous shoppers / fair attendees, so:
//   • MEDICATION  → withheld (sanitary detail, regulated)
//   • FEED_RECORD → withheld (commercial)
//   • DIET_CHANGE → withheld (commercial)
//   • daily MilkProduction rows → withheld (commercial)
//   • reproductive cycle (ESTRO, INSEMINATION, PREGNANCY_CHECK) → withheld
//
// What remains is the public storyline a buyer / consumer cares about: birth,
// vaccinations, health check outcomes, transfers between farms, ownership
// changes, auction milestones, and the physical transport custody chain.
//
// Phase 12 (ADR-015 §5.1, phase-12 PRD §4 closed decision) — TRANSPORT_PICKUP
// / TRANSPORT_DELIVERY ARE public: they show the journey (origin → destination)
// without exposing the transporter's personal data, which lives in the private
// `data_json` payload the QR template never renders.
export const PUBLIC_EVENT_TYPES = [
    'BIRTH',
    'VACCINE',
    'HEALTH_CHECK',
    'TRANSFER',
    'OWNERSHIP_TRANSFER',
    'AUCTION_LISTED',
    'AUCTION_SOLD',
    'TRANSPORT_PICKUP',
    'TRANSPORT_DELIVERY',
];
const PUBLIC_EVENT_SET = new Set(PUBLIC_EVENT_TYPES);
export function isPublicEventType(type) {
    return PUBLIC_EVENT_SET.has(type);
}
//# sourceMappingURL=public-events.js.map